<template>
  <div style="background-color: #3eaf7c; height: 100vh">
    <v-toolbar dark prominent>
      <v-app-bar-nav-icon>
        <v-icon color="blue darken-2" @click="backButton">
          mdi-arrow-left
        </v-icon>
      </v-app-bar-nav-icon>

      <v-col cols="12" md="11" sm="12">
        <v-img
          src="/img/fantasy_lineups_logo.png"
          class="logo mx-auto"
          width="350"
          contain
        />
      </v-col>
    </v-toolbar>

    <div align="center" class="h_iframe">
      <v-sheet rounded elevation="2" width="420" class="ma-5 pa-3">
        <p class="font-weight-bold text-h6">Contact Us</p>
        <span class="body-1 font-weight-medium"
          >If you have any questions, or looking to cancel your membership feel
          free to contact at:
          <a href="mailto:support@fantasylineups.com"
            >support@fantasylineups.com</a
          ><br />
          <span>Someone will get back to you within 24 hours.</span>
        </span>
      </v-sheet>
    </div>
  </div>
</template>

<script>
export default {
  name: "ClickBankContactPage",

  beforeRouteEnter(to, from, next) {
    if (localStorage.getItem("status") == "active") {
      next();
    } else {
      next("/login");
    }
  },

  methods: {
    backButton() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped type="text/css" media="screen, projection">
/* @import url(https://s3.amazonaws.com/assets.freshdesk.com/widget/freshwidget.css); */
.h_iframe iframe {
  /* position: absolute;
    top: 0;
    left: 0;
    width: 100%; */
  height: 100%;
}

body::-webkit-scrollbar {
  display: none;
}
</style>
